module.exports = __webpack_public_path__ + "img/haarlem_landing_mobile.6a683616.jpg";